<template>
  <div>
    <!-- Pagina 1 -->
    <div style="width: 100%; text-align: center;margin-bottom:30px">
      <img :src="getLogo" style="height: 200px" />
    </div>

    <div style="width: 80%; margin-left: auto; margin-right: auto">
      <div style="float:left;width:70%">
        <h2>{{ clienteNombreCompleto }}</h2>
        <p style="font-size:18px">
          {{ datos.cliente.contacto.direccion }}{{ ", " + datos.cliente.contacto.cp }}{{ (datos.cliente.contacto.localidad.municipio && ", " + datos.cliente.contacto.localidad.municipio.nombre) || "" }}{{ (datos.cliente.contacto.localidad.provincia && ", " + datos.cliente.contacto.localidad.provincia.nombre) || "" }}.
        </p>
        <p>Att: {{ datos.auditores[0].nombre_completo }}</p>
      </div>
      <div style="float:left;width:30%">
        <table>
          <tr>
            <td colspan="2">REGISTRO DOCUMENTOS</td>
          </tr>
          <tr>
            <td><input type="checkbox">ENTADA</td>
            <td><input type="checkbox" checked>SALIDA</td>
          </tr>
          <tr>
            <td colspan="2">
              Nº REGISTRO: {{ datos.codigo }}<br />
              FECHA: {{ shortFormatDate() }} <input type="checkbox"> ANEJOS <br />
              ARCHIVO:
            </td>
          </tr>
        </table>
      </div>
      <div style="clear:both"></div>
    </div>

    <div style="width: 80%; margin-left: auto; margin-right: auto;margin-top:20px">
      <p style="text-align:right">{{ (datos.cliente.provincia && datos.cliente.provincia.nombre) || "" }}, a
        {{ formatDate(datos.created_at) }}</p>
      <p><b>ASUNTO: INFORME AUDITORÍA,</b></p>
      <p>Estimado Sr.: </p>
      <p>Adjunto le remito el informe de la auditoría de Certificación del Expediente {{ datos.expediente.codigo }},
        para la Norma de Calidad para la carne, el Jamón, la Paleta y la Caña de Lomo Ibéricos modificado tras detectar
        un error en el informe original.</p>
      <p>Cualquier duda o comentario, quedamos a su disposición.</p>
      <p>A la espera de sus noticias, reciba un cordial saludo.</p><br /><br />
      <p>Fdo.: {{ datos.auditores[0].nombre_completo }}</p>
      <p>Auditor jefe</p>
    </div>

    <!-- Pagina 2 -->
    <div class="page-break-before"></div>

    <div style="width: 80%; margin-left: auto; margin-right: auto">
      <b>INDICE</b>
      <hr />
      <p>
        <ol>
          <li>DATOS GENERALES.</li>
          <li>ALCANCE DE CERTIFICACIÓN.</li>
          <li>OBJETO.</li>
          <li>DOCUMENTOS NORMATIVOS. DOCUMENTACIÓN APLICABLE Y DE REFERENCIA.</li>
          <li>RESUMEN DE EVALUACIÓN. CUMPLIMIENTO GENERAL POR PARTE DEL OPERADOR DE LOS REQUISITOS DE CERTIFICACIÓN.
          </li>
          <li>CONCLUSIONES Y CONTINUACIÓN DEL PROCESO DE CERTIFICACIÓN.</li>
        </ol>
        <ul>
          <li>ANEXO I: CLASIFICACIÓN DE LOS INCUMPLIMIENTOS. TIPOLOGÍA.</li>
        </ul>
      </p>
      <hr />

      <p><b>TERMINOLOGÍA:</b></p>

      <table>
        <tbody>
          <tr>
            <td style="width:25%;text-align:center"><b>Operador (RD 4/2014):</b></td>
            <td style="width:75%;text-align: justify;">Persona física o jurídica que interviene en alguna de las fases
              del proceso de producción, transformación, comercialización incluida la distribución y reetiquetado,
              responsable de asegurar que sus productos cumplen con los requisitos establecidos en la Norma de Calidad,
              y por tanto, deberá establecer un sistema de autocontrol de las operaciones que se realicen bajo su
              responsabilidad.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Operador (PG-14-CPA):</b></td>
            <td style="width:75%;text-align: justify;">Agente económico u organización. Parte responsable de asegurar
              que sus productos /servicios, cumplen y, si aplica, continúan cumpliendo con los criterios en los cuales
              se basa la certificación.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Empresa alimentaria:</b></td>
            <td style="width:75%;text-align: justify;">Toda empresa (razón social) que lleve a cabo cualquier actividad
              relacionada con cualquiera de las etapas de la producción, transformación y comercialización de alimentos,
              que tiene la correspondiente autorización sanitaria de funcionamiento, asociada a la razón social y al
              domicilio industrial.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Establecimiento / centro:</b></td>
            <td style="width:75%;text-align: justify;">Cualquier unidad de una empresa alimentaria.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Auditoría:</b></td>
            <td style="width:75%;text-align: justify;">Proceso sistemático, independiente y documentado para obtener
              evidencias de la auditoría y evaluarlas de manera objetiva con el fin de determinar la extensión en que se
              cumplen los criterios de auditoría.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Criterios de auditoría:</b></td>
            <td style="width:75%;text-align: justify;">Conjunto de políticas, procedimientos o requisitos (utilizados
              como referencia frente a la cual se compara la evidencia de la auditoría/ referencia frente a la cual se
              determina la conformidad.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Muestreo:</b></td>
            <td style="width:75%;text-align: justify;">Obtención de una muestra representativa del objeto de evaluación
              de la conformidad, de acuerdo con el procedimiento establecido</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Evidencia objetiva:</b></td>
            <td style="width:75%;text-align: justify;">Registros, declaraciones de hechos, o cualquier otra información
              que son pertinentes para los criterios de auditoría y que son verificables.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Hallazgo de auditoría:</b></td>
            <td style="width:75%;text-align: justify;">Resultados de la evaluación de las evidencias recopilados frente
              a los criterios de la auditoría.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>No conformidad:</b></td>
            <td style="width:75%;text-align: justify;">Incumplimiento, por parte del establecimiento auditado, de alguno
              de los requisitos especificados en los documentos de referencia que le son de aplicación a esta
              certificación. La clasificación de los incumplimientos se describe en el Anexo I del presente Informe de
              auditoría.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Observación:</b></td>
            <td style="width:75%;text-align: justify;">Aspectos del sistema que a juicio del equipo auditor pueden dar
              lugar a No Conformidades en un futuro, en los que existe una evidente posibilidad de mejora. Una
              observación también puede incluir una solicitud realizada por CERTICAR al operador auditado para que tome
              alguna acción concreta. Las observaciones no impiden ni suspenden el proceso de certificación.</td>
          </tr>
          <tr>
            <td style="width:25%;text-align:center"><b>Conclusiones de auditoría:</b></td>
            <td style="width:75%;text-align: justify;">Resultado de una auditoría que proporciona el equipo auditor tras
              considerar los objetivos de la auditoría y todos los hallazgos de la auditoría.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagina 3 -->
    <div class="page-break-before"></div>

    <div style="width: 80%; margin-left: auto; margin-right: auto">
      <p style="text-align:center;border-top:1 solid black;border-bottom:1 solid black;background-color:#e6e6e6">
        <b>INFORME DE AUDITORÍA DE CERTIFICACIÓN DE PRODUCTO CONFORME A LOS REQUISITOS DE LA NORMA DE CALIDAD PARA LA
          CARNE, EL JAMÓN, LA PALETA Y LA CAÑA DE LOMO IBÉRICO RD 4/2014</b></p>

      <ol>
        <li style="margin-top:10px;margin-bottom:10px"><b>
            <ul>DATOS GENERALES:</ul>
          </b></li>
        <ol>
          <li style="margin-top:10px;margin-bottom:10px"><b>AUDITORÍA:</b></li>
          <ul>
            <li>Equipo auditor de CERTICAR, S.L.: {{ datos.auditores[0].nombre_completo }}</li>
            <li>Fecha de auditoría: {{ shortFormatDate(datos.desde) }}</li>
            <li>Tipo auditoría: {{ datos.tipo_visita }}</li>
            <li><b>Confidencialidad:</b> Durante el transcurso de la auditoría se comunicó que toda la información
              obtenida, y registros aportados, seria tratada, a todos los efectos, de forma confidencial.</li>
          </ul>
          <li style="margin-top:10px;margin-bottom:10px">
            <b>DATOS DEL OPERADOR:</b>

            <table style="margin-top:10px;margin-bottom:10px">
              <tbody>
                <tr>
                  <td style="width:50%;background-color:#e6e6e6">RAZÓN SOCIAL</td>
                  <td>{{ clienteNombreCompleto }}</td>
                </tr>
                <tr>
                  <td style="width:50%;background-color:#e6e6e6">DIRECCIÓN</td>
                  <td>
                    {{ datos.cliente.contacto.direccion }}.
                  </td>
                </tr>
                <tr>
                  <td style="width:50%;background-color:#e6e6e6">LOCALIDAD</td>
                  <td>{{ (datos.cliente.contacto.localidad.municipio && ", " + datos.cliente.contacto.localidad.municipio.nombre) || "" }},
                    {{ datos.cliente.contacto.cp }}</td>
                </tr>
                <tr>
                  <td style="width:50%;background-color:#e6e6e6">PROVINCIA</td>
                  <td>{{ (datos.cliente.contacto.localidad.provincia && datos.cliente.contacto.localidad.provincia.nombre) || "" }}</td>
                </tr>
                <tr>
                  <td style="width:50%;background-color:#e6e6e6">PERSONAL DELEGADO A EFECTOS DE LA CERTIFICACIÓN</td>
                  <td>{{ datos.cliente.responsable_nombre }} {{ datos.cliente.responsable_primer_apellido }}
                    {{ datos.cliente.responsable_segundo_apellido }}</td>
                </tr>
              </tbody>
            </table>
          </li>
          <li style="margin-top:10px;margin-bottom:10px">
            <b>DOMICILIO/S INDUSTRIAL/ES</b>

            <div v-for="instalacion in datos.cliente.instalaciones" :key="instalacion.uuid">
              <table style="width:100%;">
                <tr>
                  <td style="width:50%; background-color: grey"><strong>NOMBRE</strong></td>
                  <td>{{instalacion.razon_social}}</td>
                </tr>
                <tr>
                  <td style="width:50%; background-color: grey"><strong>DIRECCIÓN</strong></td>
                  <td>{{instalacion.direccion}}</td>
                </tr>
                <tr>
                  <td style="width:50%; background-color: grey"><strong>LOCALIDAD</strong></td>
                  <td>{{instalacion.municipio.nombre}}</td>
                </tr>
                <tr>
                  <td style="width:50%; background-color: grey"><strong>PROVINCIA</strong></td>
                  <td>{{instalacion.provincia.nombre}}</td>
                </tr>
                <tr>
                  <td style="width:50%; background-color: grey"><strong>Nº RGSEAA</strong></td>
                  <td>{{instalacion.rgseaa}}</td>
                </tr>
                <tr>
                  <td style="width:50%; background-color: grey"><strong>ACTIVIDAD INSCRITA:</strong></td>
                  <td>
                    <span v-for="tramite in instalacion.tramites" :key="tramite.uuid">{{tramite.codigo}}
                      {{tramite.nombre}}</span>
                  </td>
                </tr>
              </table>
            </div>

          </li>
          <li style="margin-top:10px;margin-bottom:10px">
            <b>IDENTIFICACIÓN INSTALACIONES AUDITADAS:</b>

            <div v-for="instalacion in datos.cliente.instalaciones" :key="instalacion.uuid">
              <table style="width:100%;">
                <tr>
                  <td style="width:50%; background-color: grey"><strong>Nº RGSEAA</strong></td>
                  <td>{{instalacion.rgseaa}}</td>
                </tr>
                <tr>
                  <td style="width:50%; background-color: grey"><strong>ALCANCE DE PROCESO AUDITADO</strong></td>
                  <td>{{datos.alcance.nombre}}</td>
                </tr>
              </table>
            </div>
          </li>
        </ol>
        <li style="margin-top:10px;margin-bottom:10px"><b><u>ALCANCE DE CERTIFICACIÓN: </u></b></li>
        <ol>
          <li style="margin-top:10px;margin-bottom:10px"><b>ALCANCE DE CERTIFICACIÓN SOLICITADO: </b></li>
          <ol>
            <li>
              <b>ALCANCE DE CERTIFICACIÓN DE PRODUCTO <span style="color:red">PROPIO</span></b>



              <div v-for="instalacionSite in instalacionesAuditadasSites" :key="instalacionSite.uuid">
                <div
                  v-for="site in getSiteDataAggroupedBy(datos.sites.filter(x => x.parent_uuid == instalacionSite.uuid), 'producto')"
                  :key="site.key">

                  <br>
                  <br>
                  <table style="width:100%; text-align:center;">
                    <tbody>
                      <tr>
                        <td rowspan="4" style="background-color: grey;">
                          <p><strong>ALCANCE DE PROCESO:</strong></p>
                        </td>
                        <td>
                          <p>ACTIVIDADES PROPIAS:</p>
                        </td>
                        <td>
                          <p>RGSEAA:</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p v-for="categoria in getataAggroupedBy(site.values, 'categoria')" :key="categoria.key">
                            {{categoria.key}}
                          </p>
                        </td>
                        <td>
                          <p>{{instalacionSite.nombre.split("-")[1]}}</p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <p>ACTIVIDADES SUBCONTRATADAS:</p>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <p v-for="actividad in getataAggroupedBy(site.values, 'actividad')" :key="actividad.key">
                            {{actividad.key}}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br>
                  <table style="width:100%">
                    <tbody>
                      <tr style="text-align:center;">
                        <td :rowspan="getataAggroupedBy(site.values, 'nombre').length+3"
                          style="background-color: grey;">
                          <p><strong>&nbsp;</strong></p>
                          <p><strong>ALCANCE PRODUCTO</strong></p>
                        </td>
                        <td>
                          <p>TIPO</p>
                        </td>
                        <td colspan="2">
                          <p><strong>{{site.key}}</strong></p>
                        </td>
                      </tr>

                      <tr v-for="(producto, nro) in getataAggroupedBy(site.values, 'nombre') " :key="producto.key">
                        <td style="text-align:center;" :rowspan="getataAggroupedBy(site.values, 'nombre').length"
                          v-if="nro == 0">
                          <p>DENOMINACI&Oacute;N DE VENTA</p>
                        </td>
                        <td>
                          <p>{{nro}}</p>
                        </td>
                        <td>
                          <p>{{producto.key.split(')').slice(-1)[0]}}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p>ETIQUETADO MARCA COMERCIAL</p>
                        </td>
                        <td colspan="2">
                          <p v-for="marca in getataAggroupedBy(site.values, 'marca')" :key="marca.key">{{marca.key}}</p>
                        </td>
                      </tr>

                      <tr>
                        <td>
                          <p>PRESENTACIÓN COMERCIAL</p>
                        </td>
                        <td colspan="2" style="
    font-weight: bold;
    text-align: center;
">
                          <p v-for="presentacion in getataAggroupedBy(site.values, 'presentacion')"
                            :key="presentacion.key">{{presentacion.key}}</p>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>

              <p style="color: blue;">
                (*) EN TRANSFORMACIÓN, ESPECIFICAR ACTIVIDADES CONCRETAS: DESHUESADO, TROCEADO, FRACCIONADO, LONCHEADO.
                <br>
                (**) TRAS TRANSFORMACIÓN SUBCONTRATADA, ESPECIFICAR SI APLICA ENVASADO Y/O ETIQUETADO O NO

              </p>

            </li>
            <li><b>ALCANCE DE CERTIFICACIÓN DE <strong style="color:red;">PROCESO</strong> – PRESTACIÓN DE SERVICIOS A
                MAQUILA:</b>

              <table v-for="maquila in getInstalacionesMaquila()" :key="maquila.rgseaa">
                <tr>
                  <td style="width:20%; background-color: grey"><strong>ALCANCE DE PROCESO:</strong></td>
                  <td style=" color:red;">
                    <span v-for="actividad in getDistinctActividadesByRgseea(maquila.rgseaa)" :key="actividad">
                      PROCESO DE {{actividad}} A MAQUILA
                    </span>
                  </td>
                  <td style="width:15%; background-color: grey; color:red;">{{maquila.rgseaa}}</td>
                </tr>
              </table>

            </li>

            <li>
              <b>ACTIVIDADES O SERVICIOS SUBCONTRATADOS:</b>
              BAJO CERTIFICACIÓN ACREDITADA:
              <div v-if="getDistinctActividadesMaquila().length == 0">
                <strong>NO APLICA</strong>
              </div>
              <div v-else>
                <table v-for="actividad in getDistinctActividadesMaquila()" :key="actividad">
                  <tr>
                    <td>ACTIVIDAD</td>
                    <td>RAZÓN SOCIAL</td>
                    <td>ENTIDAD DE CERTIFICACIÓN</td>
                    <td>VALIDEZ CERTIFICADO</td>
                  </tr>
                  <tr>
                    <td style="width:20%; color:red"><strong>{{actividad}}</strong></td>
                    <td style=" color:red;">
                      <span v-for="maquila in getInstalacionesMaquila().filter(x => x.actividad == actividad)"
                        :key="maquila.rgseaa">
                        {{maquila.razon_social}}
                      </span>
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>

                <div style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                    <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>SIN CERTIFICACI&Oacute;N
                        ACREDITADA:</span></strong></p>
                  <table style="width: 4.2e+2pt;border-collapse:collapse;border:none;">
                    <tbody>
                      <tr>
                        <td style="width:141.85pt;border:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ACTIVIDAD</span></p>
                        </td>
                        <td
                          style="width:141.3pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;'>RAZ&Oacute;N SOCIAL</span></p>
                        </td>
                        <td
                          style="width:141.55pt;border:solid black 1.0pt;border-left:  none;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;'>FECHA DE
                              AUDITOR&Iacute;A</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;'>POR CERTICAR</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="width:141.85pt;border:solid black 1.0pt;border-top:none;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span
                              style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>DESHUESADO,&nbsp;</span>
                          </p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>TROCEADO</span>
                          </p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>LONCHEADO</span>
                          </p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ENVASADO</span>
                          </p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ETIQUETADO</span>
                          </p>
                        </td>
                        <td
                          style="width:141.3pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                        </td>
                        <td
                          style="width:141.55pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                            <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:justify;'>
                    <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                </div>
              </div>
            </li>
          </ol>
          <li>
            <strong><span
                style='font-family:"Arial",sans-serif;color:red;font-size:13px;color:red;'><b>MODIFICACI&Oacute;N DE
                  ALCANCE, EVALUADO EN EL TRANSCURSO DE LA AUDITOR&Iacute;A:&nbsp;</b></span></strong>
            <div style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:justify;'>
                <span style='font-size:13px;font-family:"Arial",sans-serif;'>El operador solicita con fecha XXX la
                  <strong>modificaci&oacute;n del alcance de certificaci&oacute;n para</strong>:</span></p>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:justify;'>
                <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
              <div style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                <ul style="margin-bottom:0cm;list-style-type: undefined;margin-left:26px;">
                  <li style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                    <strong><span style='font-family:"Arial",sans-serif;'>PRODUCTO PROPIOS</span></strong></li>
                </ul>
              </div>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-top:0cm;margin-right:2.85pt;margin-left:36.0pt;text-align:justify;'>
                <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
              <p style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'><span
                  style='font-size:11px;font-family:"Arial",sans-serif;'>Ej:&nbsp;</span></p>
              <table style="width: 4.3e+2pt;margin-left:-3.6pt;border-collapse:collapse;border:none;">
                <tbody>
                  <tr>
                    <td
                      style="width: 89.15pt;border: 1pt solid black;padding: 0cm 5.4pt;height: 15.75pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                        <strong><span style='font-size:13px;font-family:"Arial",sans-serif;background:lightgrey;'>RD
                            4/2014</span></strong></p>
                    </td>
                    <td colspan="4"
                      style="width: 343.2pt;border-top: 1pt solid black;border-right: 1pt solid black;border-bottom: 1pt solid black;border-image: initial;border-left: none;padding: 0cm 5.4pt;height: 15.75pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                        <strong><span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>REDUCCI&Oacute;N
                            / AMPLIACI&Oacute;N</span></strong></p>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"
                      style="width: 90.05pt;border-right: 1pt solid black;border-bottom: 1pt solid black;border-left: 1pt solid black;border-image: initial;border-top: none;padding: 0cm 5.4pt;height: 6.75pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>ALCANCE PROCESO</span></p>
                    </td>
                    <td colspan="3"
                      style="width:342.3pt;border-top:none;border-left:  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:6.75pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:12.8pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>ELABORACI&Oacute;N</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" rowspan="6"
                      style="width: 90.05pt;border-right: 1pt solid black;border-bottom: 1pt solid black;border-left: 1pt solid black;border-image: initial;border-top: none;padding: 0cm 5.4pt;height: 4.95pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:3.0pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:3.0pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:3.0pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>ALCANCE PRODUCTO</span></p>
                    </td>
                    <td
                      style="width: 144.75pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 4.95pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>TIPO</span></p>
                    </td>
                    <td colspan="2"
                      style="width: 197.55pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 4.95pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                        <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>CURADO</span></strong></p>
                    </td>
                  </tr>
                  <tr>
                    <td rowspan="3"
                      style="width:144.75pt;border-top:none;border-left:  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:7.2pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>DENOMINACI&Oacute;N DE VENTA</span>
                      </p>
                    </td>
                    <td
                      style="width: 38.25pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.15pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>1</span></p>
                    </td>
                    <td
                      style="width: 159.3pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:-.1pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 38.25pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.15pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>2</span></p>
                    </td>
                    <td
                      style="width: 159.3pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:-.1pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 38.25pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.15pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>3</span></p>
                    </td>
                    <td
                      style="width: 159.3pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:-.1pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 144.75pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 8.25pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>ETIQUETADO MARCA COMERCIAL</span>
                      </p>
                    </td>
                    <td colspan="2"
                      style="width:197.55pt;border-top:none;border-left:  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:8.25pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:2.7pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 144.75pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 6.45pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>PRESENTACI&Oacute;N
                          COMERCIAL</span></p>
                    </td>
                    <td colspan="2"
                      style="width: 197.55pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 6.45pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:2.7pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2"
                      style="width: 90.05pt;border-right: 1pt solid black;border-bottom: 1pt solid black;border-left: 1pt solid black;border-image: initial;border-top: none;padding: 0cm 5.4pt;height: 6.75pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>ALCANCE PROCESO</span></p>
                    </td>
                    <td colspan="3"
                      style="width:342.3pt;border-top:none;border-left:  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:6.75pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:12.8pt;'>
                        <span
                          style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>COMERCIALIZACI&Oacute;N</span>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" rowspan="6"
                      style="width: 90.05pt;border-right: 1pt solid black;border-bottom: 1pt solid black;border-left: 1pt solid black;border-image: initial;border-top: none;padding: 0cm 5.4pt;height: 4.95pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:3.0pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:3.0pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:3.0pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>ALCANCE PRODUCTO</span></p>
                    </td>
                    <td
                      style="width: 144.75pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 4.95pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>TIPO&nbsp;</span></p>
                    </td>
                    <td colspan="2"
                      style="width: 197.55pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 4.95pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                        <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>FRESCO</span></strong></p>
                    </td>
                  </tr>
                  <tr>
                    <td rowspan="3"
                      style="width:144.75pt;border-top:none;border-left:  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:7.2pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>DENOMINACI&Oacute;N DE VENTA</span>
                      </p>
                    </td>
                    <td
                      style="width: 38.25pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.15pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>1</span></p>
                    </td>
                    <td
                      style="width: 159.3pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:-.1pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 38.25pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.15pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>2</span></p>
                    </td>
                    <td
                      style="width: 159.3pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:-.1pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 38.25pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.15pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>3</span></p>
                    </td>
                    <td
                      style="width: 159.3pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 7.2pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:-.1pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 144.75pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 8.25pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>ETIQUETADO MARCA COMERCIAL</span>
                      </p>
                    </td>
                    <td colspan="2"
                      style="width:197.55pt;border-top:none;border-left:  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:8.25pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:2.7pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width: 144.75pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 6.45pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:5.7pt;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>PRESENTACI&Oacute;N
                          COMERCIAL</span></p>
                    </td>
                    <td colspan="2"
                      style="width: 197.55pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 6.45pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-left:2.7pt;text-align:center;'>
                        <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td style="border:none;"><br></td>
                    <td style="border:none;"><br></td>
                    <td style="border:none;"><br></td>
                    <td style="border:none;"><br></td>
                    <td style="border:none;"><br></td>
                  </tr>
                </tbody>
              </table>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-top:0cm;margin-right:2.85pt;margin-left:2.85pt;text-align:justify;'>
                <strong><u><span style='font-size:13px;font-family:"Arial",sans-serif;'><span
                        style="text-decoration:none;">&nbsp;</span></span></u></strong></p>
              <div style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                <ul style="margin-bottom:0cm;list-style-type: undefined;margin-left:26px;">
                  <li style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                    <strong><span style='font-family:"Arial",sans-serif;'>PRESTACI&Oacute;N DE SERVICIOS A
                        MAQUILA:&nbsp;</span></strong></li>
                </ul>
              </div>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:justify;'>
                <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
              <table style="width: 4.2e+2pt;border-collapse:collapse;border:none;">
                <tbody>
                  <tr>
                    <td rowspan="2"
                      style="width:168.85pt;border:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:23.5pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>ALCANCE DE PROCESO</span></p>
                    </td>
                    <td
                      style="width:92.95pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;height:23.5pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>FRESCO</span></p>
                    </td>
                    <td
                      style="width: 78.7pt;border-top: 1pt solid black;border-right: 1pt solid black;border-bottom: 1pt solid black;border-image: initial;border-left: none;padding: 0cm 5.4pt;height: 23.5pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>CURADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                    </td>
                    <td rowspan="2"
                      style="width:84.2pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;height:23.5pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>A MAQUILA</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="width:92.95pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:23.5pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>SACRIFICIO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>DESPIECE</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span
                          style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ELABORACI&Oacute;N&nbsp;</span>
                      </p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>DESHUESADO&nbsp;</span>
                      </p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>TROCEADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>LONCHEADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ENVASADO&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ETIQUETADO</span></p>
                    </td>
                    <td
                      style="width: 78.7pt;border-top: none;border-left: none;border-bottom: 1pt solid black;border-right: 1pt solid black;padding: 0cm 5.4pt;height: 23.5pt;vertical-align: top;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>SACRIFICIO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>DESPIECE</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span
                          style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ELABORACI&Oacute;N&nbsp;</span>
                      </p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>DESHUESADO&nbsp;</span>
                      </p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>TROCEADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>LONCHEADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ENVASADO&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ETIQUETADO</span></p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:justify;'>
                <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
              <div style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                <ul style="margin-bottom:0cm;list-style-type: undefined;margin-left:10.850000000000001px;">
                  <li style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                    <strong><span style='font-family:"Arial",sans-serif;'>ACTIVIDADES O SERVICIOS
                        SUBCONTRATADOS:&nbsp;</span></strong></li>
                </ul>
              </div>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-top:0cm;margin-right:2.85pt;margin-left:36.0pt;text-align:justify;'>
                <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></strong></p>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-top:0cm;margin-right:2.85pt;margin-left:2.85pt;'>
                <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>BAJO CERTIFICACI&Oacute;N
                    ACREDITADA:</span></strong></p>
              <table style="width: 4.2e+2pt;border-collapse:collapse;border:none;">
                <tbody>
                  <tr>
                    <td style="width:106.1pt;border:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>ACTIVIDAD</span></p>
                    </td>
                    <td style="width:105.2pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>RAZ&Oacute;N SOCIAL</span></p>
                    </td>
                    <td style="width:106.9pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>ENTIDAD DE
                          CERTIFICACI&Oacute;N</span></p>
                    </td>
                    <td style="width:106.5pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>VALIDEZ</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>CERTIFICADO</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:106.1pt;border:solid black 1.0pt;border-top:none;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>SACRIFICIO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                    </td>
                    <td
                      style="width:105.2pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                    <td
                      style="width:106.9pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                    <td
                      style="width:106.5pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-top:0cm;margin-right:2.85pt;margin-left:2.85pt;text-align:justify;'>
                <strong><u><span style='font-size:13px;font-family:"Arial",sans-serif;'><span
                        style="text-decoration:none;">&nbsp;</span></span></u></strong></p>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>SIN CERTIFICACI&Oacute;N
                    ACREDITADA:</span></strong></p>
              <table style="width: 4.2e+2pt;border-collapse:collapse;border:none;">
                <tbody>
                  <tr>
                    <td style="width:5.0cm;border:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ACTIVIDAD</span></p>
                    </td>
                    <td style="width:141.35pt;border:solid black 1.0pt;border-left:  none;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>RAZ&Oacute;N SOCIAL</span></p>
                    </td>
                    <td style="width:141.6pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>FECHA DE AUDITOR&Iacute;A</span>
                      </p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>POR CERTICAR</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td style="width:5.0cm;border:solid black 1.0pt;border-top:none;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>DESHUESADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>,TROCEADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>LONCHEADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ENVASADO</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;color:red;'>ETIQUETADO</span></p>
                    </td>
                    <td
                      style="width:141.35pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                    </td>
                    <td
                      style="width:141.6pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>XX/YY/ZZ</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                      <p
                        style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                        <span style='font-size:12px;font-family:"Arial",sans-serif;'>VER NC N&ordm; XXX</span></p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p
                style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-top:0cm;margin-right:2.85pt;margin-left:2.85pt;text-align:justify;'>
                <strong><u><span style='font-size:13px;font-family:"Arial",sans-serif;'><span
                        style="text-decoration:none;">&nbsp;</span></span></u></strong></p>
            </div>
          </li>
        </ol>
        <li>
          <b><u>OBJETO:</u></b>
          <p>
            El objeto de la auditoría de certificación es:
            <ul>
              <li>Verificar el cumplimiento de los requisitos de certificación por parte del operador solicitante de la
                certificación.</li>
              <li>Determinar la adecuación de producto/proceso objeto de certificación respecto a los criterios
                descritos en los documentos aplicables y de referencia.</li>
            </ul>
          </p>
        </li>
        <li>
          <b><u>DOCUMENTOS NORMATIVOS. DOCUMENTACIÓN APLICABLE Y DE REFERENCIA:</u></b>
          <p>
            <ul>
              <li>Real Decreto 4/2014, de 10 de enero, por el que se aprueba la norma de calidad para la carne, el
                jamón, la paleta y la caña de lomo ibéricos.</li>
              <li>Protocolo de Certificación, 08/05/2017_E-1 y acuerdos de interpretación normativa establecidos por la
                Mesa de Coordinación de la norma de calidad del ibérico.</li>
              <li>Esquema de acreditación de entidades de certificación de operadores que elaboran, transforman,
                comercializan y distribuyen productos amparados por la norma de calidad de ibérico. RDE-13 Rev. 2 –
                Junio 2018.</li>
              <li>Reglamento (UE) Nº 1169/2011 del Parlamento Europeo y del Consejo, de 25 de octubre de 2011, sobre la
                información alimentaria facilitada al consumidor.</li>
              <li>Real Decreto 474/2014, de 13 de junio, por el que se aprueba la norma de calidad de derivados
                cárnicos.</li>
              <li>PG- 14-CPA: Procedimiento General de Certificación de Productos Agroalimentarios.</li>
              <li>PG-13: Procedimiento General de Uso de la marca de CERTICAR.</li>
              <li>PE-NCI-04: Procedimiento Especifico. Criterios Específicos del Proceso de Auditoría para la
                Certificación de Producto norma de calidad jamón, paleta y caña de lomo ibéricos.</li>
              <li>Notas Técnicas publicadas por CERTICAR.</li>
              <li>Informe de la anterior auditoría (si aplica).</li>
            </ul>
          </p>
        </li>
        <li>
          <u><b>RESUMEN DE LA EVALUACIÓN. CUMPLIMIENTO GENERAL POR PARTE DEL OPERADOR DE LOS REQUISITOS DE
              CERTIFICACIÓN: </b></u>
          <p>La auditoría al operador se llevó a cabo conforme al plan de auditoría.</p>
          <p>A continuación, se detallan los resultados de la evaluación realizada sobre el grado de cumplimiento, por
            parte del operador de los requisitos especificados en la documentación de aplicable y de referencia.</p>

          <ol>
            <li>
              <b>Informe de la Auditoría In Situ.</b>
              <ol>
                <li>
                  <b>Informe de la Revisión documental durante la auditoría</b>
                  <p>Se realiza la revisión (existencia e idoneidad) de los documentos y los registros generados tras la
                    implantación del sistema de autocontrol.</p>
                  <p style="color: red;">El operador presenta su sistema de autocontrol en el documento denominado:
                    “NOMBRE DOCUMENTO”, de fecha XX de 20YY, debidamente paginado y aprobado.</p>
                  <p>Respecto a la evaluación de la documentación presentada, se verifica que los registros y documentos
                    del sistema de autocontrol se ajustan a lo requerido por la documentación aplicable y de referencia.
                  </p>
                </li>
                <li>
                  <b>Informe de la auditoría realizada en las instalaciones</b>
                  <p>La realización de esta auditoría y los resultados encontrados son fruto de una investigación
                    muestral, por lo que no se descarta la aparición de otros incumplimientos, diferentes en posteriores
                    auditorías.</p>


                  <p><b>A. Comprobaciones realizadas y resultado de las mismas:</b></p>
                  <table v-for="actividad in instalacionesAuditadasActividades()" :key="actividad">
                    <tr>
                      <td colspan="2" style="border:0px;"><strong>{{actividad}}</strong></td>
                      <td style="background-color: grey; color:red"><strong>RESULTADO EVALUACIÓN</strong></td>
                    </tr>
                    <tr>
                      <td style="color:red"><strong>PENDIENTE</strong></td>
                      <td style="color:red"><strong>ACTIVIDADES OBJETO DE CERTIFICACIÓN INCLUIDAS EN EL RGSEAA</strong>
                      </td>
                      <td style="color:red"></td>
                    </tr>
                  </table>

                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:justify;'>
                    <span style='font-size:13px;font-family:"Arial",sans-serif;'>En funci&oacute;n del volumen de
                      producci&oacute;n declarado por el operador, en el transcurso de la auditoria se procede a la
                      realizaci&oacute;n de los siguientes ejercicios de trazabilidad, con el siguiente
                      resultado:</span></p>
                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                    <br></p>
                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                    <u><span style='font-size:13px;font-family:"Arial",sans-serif;color:#4472C4;'>DOCUMENTAR &nbsp;
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;EN FUNCI&Oacute;N DEL ALCANCE DE CERTIFICACI&Oacute;N.
                        EJEMPLOS</span></u></p>


                  <div v-for="presentacion in getSiteDataAggroupedBy(datos.sites.filter(x => x.tipo != 'instalacion'), 'nombre')" :key="presentacion">
                    <p
                      style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                      <br></p>
                    <p
                      style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                      <br></p>
                    <p
                      style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                      <u><span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>EJERCICIOS DE
                          TRAZABILIDAD:&nbsp;</span></u></p>
                    <table style="width:99.54%;border-collapse:collapse;border:none;">
                      <thead>
                        <tr>
                          <td
                            style="width:39.32%;border:solid windowtext 1.0pt;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>LOTES
                                  VERIFICADOS</span></strong></p>
                          </td>
                          <td
                            style="width:39.7%;border:solid windowtext 1.0pt;border-left:   none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO
                                  ELABORADO</span></strong></p>
                          </td>
                          <td
                            style="width:20.98%;border:solid windowtext 1.0pt;border-left:none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>RESULTADO
                                  EVALUACI&Oacute;N</span></strong></p>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO /
                                  DENOMINACI&Oacute;N DE VENTA</span></strong></p>
                          </td>
                          <td
                            style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                              <span
                                style='font-size:13px;font-family:"Arial",sans-serif;'>{{presentacion.key.split(' ').slice(1).join(' ')}}</span></p>
                          </td>
                          <td rowspan="2"
                            style="width:20.98%;border-top:none;border-left:  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;'>CONFORME</span></p>
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;'>NO CONFORME</span></p>
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;'>(VER NC N&ordm; X)</span></p>
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;'>NO APLICA</span></p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>N&ordm;
                                  IDENTIFICACI&Oacute;N / PRECINTO / LOTE</span></strong></p>
                          </td>
                          <td
                            style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>

                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO /
                                  DENOMINACI&Oacute;N DE VENTA</span></strong></p>
                          </td>
                          <td
                            style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                          </td>
                          <td rowspan="2"
                            style="width:20.98%;border-top:none;border-left:  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <strong><span
                                  style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></strong>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="width: 39.32%;border-right: 1pt solid windowtext;border-bottom: 1pt solid windowtext;border-left: 1pt solid windowtext;border-image: initial;border-top: none;background: rgb(230, 230, 230);padding: 0cm 5.4pt;height: 24.1pt;vertical-align: top;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>N&ordm;
                                  IDENTIFICACI&Oacute;N / PRECINTO / LOTE</span></strong></p>
                          </td>
                          <td
                            style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                              <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p
                      style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                      <span style='font-size:11px;font-family:"Arial",sans-serif;color:#4472C4;'>Repetir tantos ejemplos
                        como N&ordm; de lotes muestreados en funci&oacute;n del volumen de producci&oacute;n /
                        a&ntilde;o.</span></p>

                  </div>


                  <div v-for="presentacion in getSiteDataAggroupedBy(datos.sites.filter(x => x.tipo != 'instalacion'), 'nombre')" :key="presentacion">

                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                    <u><span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>Evaluaci&oacute;n de
                        rendimientos de producto:</span></u></p>
                  <table style="width:99.54%;border-collapse:collapse;border:none;">
                    <thead>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>LOTES
                                VERIFICADOS</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border:solid windowtext 1.0pt;border-left:   none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <strong><span
                                style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO&nbsp;</span></strong>
                          </p>
                        </td>
                        <td
                          style="width:20.98%;border:solid windowtext 1.0pt;border-left:none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>RESULTADO
                                EVALUACI&Oacute;N</span></strong></p>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO /
                                DENOMINACI&Oacute;N DE VENTA</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>{{presentacion.key.split(' ').slice(1).join(' ')}}</span></p>

                        </td>
                        <td rowspan="2"
                          style="width:20.98%;border-top:none;border-left:  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>CONFORME</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>NO CONFORME</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>(VER NC N&ordm; X)</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>NO APLICA</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>N&ordm;
                                IDENTIFICACI&Oacute;N / PRECINTO / LOTE</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'></span></p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO /
                                DENOMINACI&Oacute;N DE VENTA</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                        </td>
                        <td rowspan="2"
                          style="width:20.98%;border-top:none;border-left:  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>N&ordm;
                                IDENTIFICACI&Oacute;N / PRECINTO / LOTE</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>&nbsp;</span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                    <span style='font-size:11px;font-family:"Arial",sans-serif;color:#4472C4;'>Repetir tantos ejemplos
                      como N&ordm; de lotes muestreados en funci&oacute;n del volumen de producci&oacute;n /
                      a&ntilde;o.</span></p>

                      </div>


                  <div v-for="presentacion in getSiteDataAggroupedBy(datos.sites.filter(x => x.tipo != 'instalacion'), 'nombre')" :key="presentacion">

                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                    <u><span style='font-size:13px;font-family:"Arial",sans-serif;'><span
                          style="text-decoration:none;">&nbsp;</span></span></u></p>
                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;'>
                    <u><span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>BALANCE DE KILOGRAMOS O
                        PIEZAS DE PRODUCTO: Se realiza sobre:</span></u></p>
                  <table style="width:99.54%;border-collapse:collapse;border:none;">
                    <thead>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>LOTE
                                VERIFICADO</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border:solid windowtext 1.0pt;border-left:   none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <strong><span
                                style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO&nbsp;</span></strong>
                          </p>
                        </td>
                        <td
                          style="width:20.98%;border:solid windowtext 1.0pt;border-left:none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>RESULTADO
                                EVALUACI&Oacute;N</span></strong></p>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>PRODUCTO /
                                DENOMINACI&Oacute;N DE VENTA</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>{{presentacion.key.split(' ').slice(1).join(' ')}}</span></p>
                        </td>
                        <td rowspan="2"
                          style="width:20.98%;border-top:none;border-left:  none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>CONFORME</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>&nbsp;</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>NO CONFORME</span></p>
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;'>(VER NC N&ordm; X)</span></p>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="width:39.32%;border:solid windowtext 1.0pt;border-top:  none;background:#E6E6E6;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                            <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>N&ordm;
                                IDENTIFICACI&Oacute;N / PRECINTO / LOTE</span></strong></p>
                        </td>
                        <td
                          style="width:39.7%;border-top:none;border-left:none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:24.1pt;">
                          <p
                            style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                            <span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'></span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <p
                    style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-right:2.85pt;text-align:center;'>
                    <span style='font-size:11px;font-family:"Arial",sans-serif;color:#4472C4;'>Repetir tantos ejemplos
                      como N&ordm; de lotes muestreados en funci&oacute;n del volumen de producci&oacute;n /
                      a&ntilde;o.</span></p>
                </div>


                  <p><b>B. Descripción de los incumplimientos detectados:</b></p>

                  <div style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                    <table v-for="checklist in datos.checklists" :key="checklist.uuid"
                      style="width: 4.3e+2pt;border-collapse:collapse;border:none;">
                      <tbody>
                        <tr>
                          <td colspan="2"
                            style="width:279.45pt;border-top:none;border-left:  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;height:37.3pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;'>INDUSTRIA
                                  C&Aacute;RNICA Y OPERADORES:</span></strong></p>
                          </td>
                          <td
                            style="width:145.5pt;border:solid black 1.0pt;border-left:none;padding:0cm 5.4pt 0cm 5.4pt;height:37.3pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:center;'>
                              <strong><span style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>RESULTADO
                                  EVALUACI&Oacute;N</span></strong></p>
                          </td>
                        </tr>
                        <tr v-for="pregunta in checklist.preguntas" :key="pregunta.uuid">
                          <td
                            style="width: 67.75pt;border-right: 1pt solid black;border-bottom: 1pt solid black;border-left: 1pt solid black;border-image: initial;border-top: none;padding: 0cm 5.4pt;vertical-align: top;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <strong><span
                                  style='font-size:13px;font-family:"Arial",sans-serif;color:red;'>{{pregunta.codigo}}</span></strong>
                            </p>
                          </td>
                          <td
                            style="width:211.7pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;text-align:justify;'>
                              <strong><span
                                  style='font-size:13px;font-family:"Arial",sans-serif;color:red;'><span v-html="pregunta.titulo"></span></span></strong>
                            </p>
                          </td>
                          <td
                            style="width:145.5pt;border-top:none;border-left:none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;">
                            <p
                              style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
                              <span style="color:red;">
                                {{pregunta.respuesta == 'V' ? 'C' : 'NC'}}
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <br><br><br>

                </li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <b><u>CONCLUSIONES Y CONTINUACIÓN DEL PROCESO DE CERTIFICACIÓN: </u></b>
          <p>El presente informe recoge una descripción de las evaluaciones, comprobaciones y verificaciones realizadas
            y los incumplimientos detectados por el auditor durante la evaluación.</p>
          <p>La auditoría se desarrolló según la programación establecida. El personal se mostró colaborador e
            interesado, lo que ha permitido llevar a cabo la auditoría de una forma eficaz.</p>
          <p>CERTICAR ha evaluado los aspectos referidos a la competencia técnica del operador para el alcance reseñado
            en el Informe.</p>
          <p>CERTICAR ha realizado la auditoría conforme a sus procedimientos de gestión. Todos los requisitos definidos
            en los documentos normativos aplicables y de referencia han podido ser evaluados documentalmente y/ o in
            situ de forma adecuada con los procedimientos antes referidos, y las actividades que realiza el operador
            auditado pueden ser suficientes para declarar la capacidad técnica para desarrollar las actividades
            referidas en el alcance de la certificación de producto.</p>
          <p>Los incumplimientos considerados por el equipo auditor como no conformidades se han clasificado en función
            de su gravedad, y se indican en los diferentes apartados de este informe, numerados de forma secuencial.
            Todos los incumplimientos fueron comunicados al operador en el transcurso de la auditoría, así como en la
            reunión final. Los incumplimientos encontrados por el equipo auditor no representan la totalidad de los
            posibles incumplimientos existentes, por lo que, en general, se redactan de forma genérica.</p>
          <p>
            Como continuación al proceso de certificación, el operador deberá remitir a CERTICAR, SL en un plazo máximo
            de <b>2 meses</b> desde la recepción del presente informe, la documentación que justifique que, para cada
            uno de los incumplimientos identificados, el operador realiza los siguientes pasos:
            <ul>
              <li>Se ha realizado un <u>análisis de las causas</u> que motivaron la aparición de los incumplimientos y
                se han evaluado los posibles aspectos afectados por las no conformidades, y/u observaciones.</li>
              <li>Se ha establecido una <u>acción correctiva y/o preventiva</u> para garantizar que se ha subsanado el
                incumplimiento o está en vía de solución y que no se repite el incumplimiento.</li>
              <li>Se ha definido un <u>plazo previsto para la resolución de los incumplimientos.</u></li>
              <li>Se <u>evalúa la eficacia de las acciones implantadas.</u></li>
            </ul>
          </p>
          <p>El operador deberá aportar evidencias que demuestren que ha realizado las acciones solicitadas
            anteriormente. Si la no conformidad está en vías de solución, se adjuntará las evidencias disponibles y el
            plan previsto para su cierre.</p>
          <p>Esta información será estudiada por el equipo auditor para determinar si las acciones propuestas y las
            evidencias remitidas aportan la suficiente confianza en que los incumplimientos han sido adecuadamente
            resueltos y serán revisadas y dictaminadas por el Director Técnico de la entidad. En caso de resultado
            insatisfactorio y/o dictamen desfavorable se procederá a aplicar las medidas estipuladas en el Protocolo de
            Certificación y en el Anexo I del presente Informe de Auditoría.</p>
          <p>Si procede una suspensión temporal o retirada del Certificado de Conformidad de Producto, esta será
            comunicada por CERTICAR a la autoridad competente de la CCAA correspondiente, indicándole las razones de las
            mismas, así como si se ha expedido producto no conforme incorrectamente etiquetado.</p>
          <p>La comunicación de realizará dentro de los plazos establecidos por cada CCAA y si no hay plazo la
            comunicación se realizará en 24 horas.</p>
          <p>Asimismo, se informará a ASICI cuando se trate de un operador que gestiona precintos de la norma de
            calidad.</p>
          <p>El operador puede alegar aquellos extremos del informe con los que no esté de acuerdo adjuntando toda la
            información que justifique su postura.</p>
          <p>El informe de auditoría tiene un plazo de validez de 6 meses desde la fecha de realización de la auditoría.
            Transcurrido dicho periodo CERTICAR se reserva el derecho de realizar una auditoría extraordinaria para
            comprobar el cumplimiento de los criterios de certificación o iniciará la aplicación del correspondiente
            trámite de sanción.</p>
          <p>Fdo.: {{ datos.auditores[0].nombre_completo }}</p>
          <p>Auditor jefe</p>
        </li>
      </ol>
    </div>

    <!-- Otra Pagina -->
    <div class="page-break-before"></div>

    <div style="width: 80%; margin-left: auto; margin-right: auto">
      <p style="text-align:center;border-top:1 solid black;border-bottom:1 solid black;background-color:#e6e6e6">
        <b>ANEXO</b><br /><b>CLASIFICACIÓN DE LOS INCUMPLIMIENTOS. TIPOLOGÍA.</b></p>
      <p>Se consideran No Conformidades definidas en el Protocolo de Certificación 08/05/2017_E-1, las siguientes:</p>

      <p><b>1º No Conformidades cuya medida supone al menos la retirada inmediata de los precintos y la pérdida del
          derecho a utilizar la denominación de venta, al menos para el producto afectado.</b> Estas no conformidades
        deberán ser comunicadas por CERTICAR a ASICI para que ésta pueda gestionar los procintos de la norma de calidad
        según lo establecido en el artículo 9 del RD 4/2014:</p>

      <table style="margin-top:10px;margin-bottom:10px">
        <thead>
          <tr style="background-color:#e6e6e6">
            <th colspan="2" style="width:67%"><b>NO CONFORMIDAD <span style="color:red">GRAVE</span></b></th>
            <th><b>MEDIDA</b></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td style="width:2%">1</td>
            <td>Actuaciones incorrectas en la asignación del precinto de la Norma de Calidad por incumplimiento de la
              calificación de la alimentación o pesos mínimos de las canales.</td>
            <td rowspan="8">En el caso de los jamones y las paletas supondrá la retirada de los precintos de la Norma de
              Calidad y en todos los casos, la pérdida del derecho a utilizar en el etiquetado las Denominaciones de
              Venta del Artículo 3 del Real Decreto 4/2014 para el producto afectado por la no conformidad.</td>
          </tr>

          <tr>
            <td>2</td>
            <td>Dar conformidad a un producto y enviarlo acompañado de un Documento de expedición de producto conforme
              DEPC o de un Registro de Trazabilidad (declaración de producto conforme) para avalar la denominación de
              venta establecida en el Artículo 3 de la Norma de Calidad sin disponer del correspondiente Certificado de
              Conformidad de Producto en vigor emitido por una entidad autorizada y acreditada (o en vías de ello), o en
              su defecto, no hayan sido controlados por CERTICAR.</td>
          </tr>

          <tr>
            <td>3</td>
            <td>La comercialización de productos utilizando las Denominaciones de Venta cuando no se dispone de un
              Informe de Inspección REA o REA-LAPS original que la avale.</td>
          </tr>

          <tr>
            <td>4</td>
            <td>La comercialización de productos que no cumplen con los pesos mínimos marcados por la Norma.</td>
          </tr>

          <tr>
            <td>5</td>
            <td>La comercialización de productos que no cumplen con los tiempos de elaboración mínimos marcados por la
              Norma.</td>
          </tr>

          <tr>
            <td>6</td>
            <td>La comercialización de jamones y paletas que utilicen etiquetas con una Denominación de Venta que no
              sean coincidente con los precintos de colores de la Norma de Calidad.</td>
          </tr>

          <tr>
            <td>7</td>
            <td>La comercialización de lomos que utilicen etiquetas con una Denominación de Venta que no sea coincidente
              con la contenida en el Informe de Inspección REA o REA-LAPS original que la avale.</td>
          </tr>

          <tr>
            <td>8</td>
            <td>La comercialización de producto sin las identificaciones que aseguren su trazabilidad o con una
              identificación ilegible.</td>
          </tr>
        </tbody>
      </table>

      <p><b>Nota interpretativa para la retirada de precintos:</b></p>
      <p>Es responsabilidad del operador que ostente la propiedad del producto, o en su defecto persona autorizada por
        éste, a través de un acuerdo por escrito que sea legalmente vinculante, la retirada de los precintos de los
        jamones y paletas ibéricas, en caso de incurrir en no conformidades incluidas en este apartado. Se debe informar
        a ASICI de la retirada y guardar los precintos retirados, hasta que CERTICAR realice el control sobre la
        adecuada gestión del producto no conforme y verifique que se informó de la retirada de los precintos a ASICI.
      </p>
      <p>Cuando los incumplimientos sean detectados en operadores que prestan servicios (maquilas), CERTICAR verificará
        la correcta gestión de retirada de precintos y la comunicación al propietario del producto sobre el producto no
        conforme y los precintos retirados. El propietario del producto, comunicará la información correspondiente a la
        retirada de precintos y el envío de éstos a ASICI. CERTICAR verificará la comunicación y la gestión de la
        información sobre el producto no conforme y sobre los precintos retirados realizada por el propietario del
        producto a ASICI.</p>

      <p><b>2º No Conformidades cuya medida es la suspensión de la certificación:</b></p>

      <!-- Otra Pagina -->
      <div class="page-break-before"></div>

      <table style="margin-top:10px;margin-bottom:10px">
        <thead>
          <tr style="background-color:#e6e6e6">
            <th colspan="2" style="width:67%"><b>NO CONFORMIDAD <span style="color:red">GRAVE</span></b></th>
            <th><b>MEDIDA</b></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td style="width:2%">1</td>
            <td>Utilizar la Marca de Conformidad de CERTICAR y la mención a la certificación en el etiquetado (vitolas)
              o en los documentos de trazabilidad (DEPC o Registro de Trazabilidad) en productos no conformes, sin
              precinto o que este fuera del alcance de la certificación.</td>
            <td rowspan="3">Suspensión de la certificación.</td>
          </tr>

          <tr>
            <td>2</td>
            <td>No facilitar a CERTICAR el acceso a las instalaciones, procedimientos y registros (actividades propias y
              subcontratadas a maquila).</td>
          </tr>

          <tr>
            <td>3</td>
            <td>No informar a CERTICAR de aquellos datos que le permitan cumplir con lo requerido por la administración
              competente conforme al Artículo 16. “Deber de Información” de la Norma de Calidad.</td>
          </tr>
        </tbody>
      </table>

      <p><b>3º No Conformidades cuya medida será establecida por la Entidad de Certificación teniendo en cuenta el
          resultado global de la evaluación y las características del operador:</b></p>

      <table style="margin-top:10px;margin-bottom:10px">
        <thead>
          <tr style="background-color:#e6e6e6">
            <th colspan="2" style="width:67%"><b>NO CONFORMIDAD <span style="color:red">GRAVE</span></b></th>
            <th><b>MEDIDA</b></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td style="width:2%">1</td>
            <td>No disponer de autorización sanitaria (RGSEAA) o que las actividades a incluir en el alcance de
              certificación no estén amparadas por el REGSEAA</td>
            <td>No concesión de la certificación.</td>
          </tr>

          <tr>
            <td>2</td>
            <td>Un incumplimiento grave reiterado respecto a evidencias de comercialización sistemática de producto con
              incumplimientos referentes a factor racial, alimentación, edad mínima, peso mínimo de las canales, falta o
              deficiente identificación de las piezas, no cumplimiento de los tiempos mínimos de curación, no
              cumplimiento del peso establecido a la comercialización e incorrecta denominación de venta en el
              etiquetado, o si se comprueba en los controles extraordinarios que no se han definido las acciones
              correctivas adecuadas para corregirlo.</td>
            <td rowspan="2">Suspensión y/o retirada de la certificación.</td>
          </tr>

          <tr>
            <td>3</td>
            <td>No acatar sin reserva los acuerdos de CERTICAR relativos a la tramitación de las evaluaciones y
              controles que se hagan para el mantenimiento del Certificado.</td>
          </tr>

          <tr>
            <td>4</td>
            <td>Actuaciones incorrectas en las etapas de sacrificio que pudieran suponer un claro riesgo para garantizar
              que, de cada lote de sacrificio, se conoce el nº de canales conformes y el nº de las desclasificadas.</td>
            <td rowspan="6">Solicitud de acción correctiva. Verificación de la implantación y efectividad de la misma
              mediante auditoría extraordinaria, en la próxima auditoría del programa de auditoría o mediante revisión
              documental, según proceda.</td>
          </tr>

          <tr>
            <td>5</td>
            <td>Actuaciones incorrectas en el sacrificio y despiece que pudieran suponer un claro riesgo para garantizar
              la formación del lote de sacrificio y del lote de despiece y su trazabilidad hasta el lote de
              alimentación.</td>
          </tr>

          <tr>
            <td>6</td>
            <td>Actuaciones incorrectas en las actividades de elaboración / fabricación o transformación que pudieran
              suponer un claro riesgo para garantizar la homogeneidad del lote (en cuanto a raza y alimentación).</td>
          </tr>

          <tr>
            <td>7</td>
            <td>Falta o deficiente identificación de las canales y/o piezas con precinto de color ASICI: No se
              considerará grave cuando pueda evidenciarse que el porcentaje del lote afectado sea inferior al 3%.</td>
          </tr>

          <tr>
            <td>8</td>
            <td>Ausencia de registros.</td>
          </tr>

          <tr>
            <td>9</td>
            <td>Imposibilidad de realización de balance de producto. Falta de correspondencia lógica entre el producto
              de entrada y salida tras la realización del mismo.</td>
          </tr>
        </tbody>
      </table>

      <!-- Otra Pagina -->
      <div class="page-break-before"></div>

      <table style="margin-top:10px;margin-bottom:10px">
        <thead>
          <tr style="background-color:#e6e6e6">
            <th colspan="2" style="width:67%"><b>NO CONFORMIDAD <span style="color:red">LEVE</span></b></th>
            <th><b>MEDIDA</b></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td style="width:2%">1</td>
            <td>Utilizar de manera incompleta o en otro orden de la denominación de venta establecida en el Artículo 3
              de la Norma de Calidad (designación por tipo de producto + designación por alimentación y manejo +
              designación por tipo racial).</td>
            <td rowspan="12">Solicitud de acción correctiva. Verificación de la implantación y efectividad de la misma
              mediante auditoría extraordinaria, en la próxima auditoría del programa de auditoría o mediante revisión
              documental, según proceda.</td>
          </tr>

          <tr>
            <td>2</td>
            <td>Incorrecta denominación de venta del producto al no situar las designaciones que componen la
              denominación de venta (designación por tipo de producto + designación por alimentación y manejo +
              designación por tipo racial) en el mismo campo visual que la marca comercial con el mismo tipo de letra,
              tamaño, grosor y color.</td>
          </tr>

          <tr>
            <td>3</td>
            <td>Utilizar los términos de “pata negra”, “dehesa” o “montanera” de manera diferente a lo que establece la
              Norma.</td>
          </tr>

          <tr>
            <td>4</td>
            <td>No indicar la expresión “Certificado por” seguido del nombre de CERTICAR (salvo en carne fresca que no
              es obligatorio).</td>
          </tr>

          <tr>
            <td>5</td>
            <td>No situar la expresión “Certificado por” seguido del nombre de CERTICAR próxima a la denominación de
              venta.</td>
          </tr>

          <tr>
            <td>6</td>
            <td>No disponer de los procedimientos mínimos requeridos en el Protocolo de Certificación para el sistema de
              autocontrol.</td>
          </tr>

          <tr>
            <td>7</td>
            <td>La carencia de los datos mínimos que debe contener el Informe de Inspección REA o REA-LAPS</td>
          </tr>

          <tr>
            <td>8</td>
            <td>No presentar, en el caso de la certificación del proceso a maquila, del acuerdo/contrato con el cliente
              que lo contrata para permitir a CERTICAR auditar con todas las garantías.</td>
          </tr>

          <tr>
            <td>9</td>
            <td>Envasar, etiquetar o comercializar productos amparados con la marca de conformidad de CERTICAR o
              referencias a la certificación cuando estos sean procedentes de operadores que no disponen de un
              Certificado de Conformidad de Producto en vigor y emitido por una entidad de certificación autorizada o en
              su defecto que no hayan sido evaluados por CERTICAR.</td>
          </tr>

          <tr>
            <td>10</td>
            <td>Registros incompletos o con carencia de datos mínimos.</td>
          </tr>

          <tr>
            <td>11</td>
            <td>Incongruencia leve en el resultado de la realización de balance de producto.</td>
          </tr>

          <tr>
            <td>12</td>
            <td>Verificaciones no satisfactorias respecto a las estipuladas en el Protocolo de Certificación.</td>
          </tr>
        </tbody>
      </table>

      <p><b>Observación:</b> Aspectos del sistema que a juicio del equipo auditor pueden dar lugar a No Conformidades en
        un futuro, en los que existe una evidente posibilidad de mejora. Una observación también puede incluir una
        solicitud realizada por CERTICAR al operador auditado para que tome alguna acción concreta. Las observaciones no
        impiden ni suspenden el proceso de certificación.</p>
    </div>

    <div class="footer" style="
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        font-size: 11px;
        border-top: 1px solid black;
        margin-top: 150px;
      ">
      <div align="center" style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;'>
        <table style="width: 4.6e+2pt;border: none;border-collapse:collapse;">
          <tbody>
            <tr>
              <td
                style="width: 369.5pt;border-right: none;border-bottom: none;border-left: none;border-image: initial;border-top: 1pt solid black;padding: 0cm 5.4pt;vertical-align: top;">
                <p
                  style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;margin-top:12.0pt;border:none;'>
                  <span style='font-size:11px;font-family:"Arial",sans-serif;color:black;'>Informe de Auditor&iacute;a
                    {{ datos.expediente.codigo }}</span></p>
              </td>
              <td
                style="width: 90pt;border-right: none;border-bottom: none;border-left: none;border-image: initial;border-top: 1pt solid black;padding: 0cm 5.4pt;vertical-align: top;">
                <img :src="getLogo" style="width: 50px; heigth: 50px;" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      datos: {
        type: Object,
        default: () => {}
      },
    },
    methods: {
      formatDate(date) {
        return date ? this.$moment(date).format("LL") : "";
      },
      shortFormatDate(date) {
        return date ? this.$moment(date).format("L") : "";
      },
      getSiteData(sites) {
        const data = [];
        if (sites) {
          for (let i = 0; i < sites.length; i++) {
            const element = sites[i];
            let obj = {};
            obj.uuid = element.uuid;
            obj.nombre = element.nombre;
            obj.tipo = element.tipo;
            for (let k = 0; k < element.site_data.length; k++) {
              const item = element.site_data[k];
              obj[item.keyname] = item.value;
            }
            data.push(obj);
          }
        }
        return data;
      },
      getSiteDataAggroupedBy(siteData, key) {
        return this.getataAggroupedBy(this.getSiteData(siteData), key);
      },
      getataAggroupedBy(data, key) {
        var agroupedData = [];
        data.forEach((site) => {
          if (site[key] === undefined) {
            return;
          }

          var elementExists = agroupedData.find((x) => x.key == site[key]);

          if (elementExists == null) {
            agroupedData.push({
              key: site[key],
              values: []
            });
          }

          agroupedData.find((x) => x.key == site[key]).values.push(site);
        });

        return agroupedData;
      },
      getDistinctActividadesByRgseea(rgseaa) {
        const activities = [];
        this.getAllMaquila().filter(x => x.rgseaa == rgseaa)
          .forEach(x => {
            if (!activities.includes(x.actividad)) {
              activities.push(x.actividad);
            }
          });

        return activities;
      },
      getDistinctActividadesMaquila() {
        const activities = [];
        this.getAllMaquila()
          .forEach(x => {
            if (!activities.includes(x.actividad)) {
              activities.push(x.actividad);
            }
          });

        return activities;
      },
      getInstalacionesMaquila() {
        const instalaciones = [];
        this.getAllMaquila()
          .forEach(x => {
            if (!instalaciones.some(inst => inst.rgseaa == x.rgseaa)) {
              instalaciones.push(x);
            }
          });

        return instalaciones;
      },
      getAllMaquila() {
        return this.datos.solicitud.params.productos.clientes;
      },
      InstalacionesAuditadas() {
        return this.datos.cliente.instalaciones.filter(x => this.instalacionesAuditadasSites.some(y => y.nombre.split(
          '-').slice(-1)[0] == x.rgseaa))
      },
      instalacionesAuditadasActividades() {
        const activities = [];
        this.InstalacionesAuditadas().forEach(inst => {
          inst.tramites.forEach(tram => {
            if (!activities.includes(tram.nombre)) {
              activities.push(tram.nombre);
            }
          })
        })
        return activities;
      }
    },
    computed: {
      clienteNombreCompleto() {
        let nombre = "";
        const cliente = this.datos.cliente;

        if (cliente) {
          if (cliente.nombre) nombre += cliente.nombre;
          if (cliente.primer_apellido) nombre += " " + cliente.primer_apellido;
          if (cliente.segundo_apellido) nombre += " " + cliente.segundo_apellido;
        }

        return nombre;
      },
      getLogo() {
        return "data:image/jpeg;base64,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";
      },
      instalacionesAuditadasSites() {
        const instalaciones = this.datos.sites.filter(x => x.tipo == 'instalacion')
        return instalaciones.filter(y => instalaciones.some(x => x.uuid == y.uuid))
      },
    },
  };
</script>

<style scoped>
  * {
    font-family: serif;
  }

  @media screen {
    div.footer {
      display: none;
    }
  }

  @media print {
    div.footer {
      border-top: 2px solid #F47BA9;
      margin-top: 10px;
      position: fixed;
      bottom: 0;
    }

    div.footer p {
      text-align: center;
    }

    table,
    table tr td,
    table tr th {
      page-break-inside: avoid;
    }
  }


  table {
    border-collapse: collapse;
  }

  table,
  th,
  td {
    padding: 5px;
    border: 0.5px solid grey;
  }

  thead {
    display: table-row-group;
  }
</style>
